import { staticComponentValueConverter } from '../StaticComponentValues';
function CargoBar_1({ item }) {
  const customization = staticComponentValueConverter(item?.customization);

  return (
    <div className="w-full h-full relative flex flex-col">
      {customization?.isShowCargoBar && (
        <div
          style={{
            padding: customization?.containerPadding,
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '33%',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <div
                  className="relative border m-[5px]"
                  style={{
                    width: 'fit-content',

                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <div
                    className=" "
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: 5,
                    }}
                  >
                    <img
                      className="shrink-0"
                      src={customization?.firstBoxIcon}
                      alt=""
                      style={{ width: customization?.iconWidth, aspectRatio: 1 }}
                    />
                  </div>
                  <div
                    style={{
                      position: 'absolute',
                      top: '-5px',
                      right: '-5px',
                      zIndex: 22,
                      backgroundColor: '#FFFFFF',
                      borderRadius: 100,
                    }}
                  >
                    <svg
                      fill="#000000"
                      width="14px"
                      height="14px"
                      viewBox="0 0 20.48 20.48"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M14.909 7.045c-0.164 -0.082 -0.41 -0.082 -0.573 0L9.257 12.288 6.881 9.83c-0.164 -0.164 -0.41 -0.164 -0.573 0s-0.164 0.41 -0.082 0.573L8.929 13.107h0.082s0.082 0 0.082 0.082h0.328s0.082 0 0.082 -0.082h0.082l5.407 -5.489c0 -0.164 0 -0.41 -0.082 -0.573z" />
                      <path d="M10.24 20.48C4.588 20.48 0 15.892 0 10.24S4.588 0 10.24 0s10.24 4.588 10.24 10.24 -4.588 10.24 -10.24 10.24m0 -19.661C5.079 0.819 0.819 5.079 0.819 10.24S5.079 19.661 10.24 19.661 19.661 15.401 19.661 10.24 15.401 0.819 10.24 0.819" />
                    </svg>
                  </div>
                </div>
              </div>
              <div
                style={{
                  color: customization?.textColor,
                  fontSize: customization?.textSize,
                  fontWeight: customization?.textWeight,
                }}
                className="truncate"
              >
                {customization?.firstText}
              </div>
              <div
                style={{
                  color: customization?.accentPriceTextColor,
                  fontSize: customization?.priceTextSize,
                  fontWeight: customization?.priceTextWeight,
                }}
              >
                ₺{customization?.firstPrice}
              </div>
            </div>
            {customization?.secondBox && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '33%',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <div
                    className="relative border m-[5px]"
                    style={{
                      width: 'fit-content',

                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <div
                      className=" "
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: 5,
                      }}
                    >
                      <img
                        className="shrink-0"
                        src={customization?.secondBoxIcon}
                        alt=""
                        style={{ width: customization?.iconWidth, aspectRatio: 1 }}
                      />
                    </div>
                    <div
                      style={{
                        position: 'absolute',
                        top: '-5px',
                        right: '-5px',
                        zIndex: 22,
                        backgroundColor: '#FFFFFF',
                        borderRadius: 100,
                      }}
                    >
                      <svg
                        fill="#000000"
                        width="14px"
                        height="14px"
                        viewBox="0 0 20.48 20.48"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M14.909 7.045c-0.164 -0.082 -0.41 -0.082 -0.573 0L9.257 12.288 6.881 9.83c-0.164 -0.164 -0.41 -0.164 -0.573 0s-0.164 0.41 -0.082 0.573L8.929 13.107h0.082s0.082 0 0.082 0.082h0.328s0.082 0 0.082 -0.082h0.082l5.407 -5.489c0 -0.164 0 -0.41 -0.082 -0.573z" />
                        <path d="M10.24 20.48C4.588 20.48 0 15.892 0 10.24S4.588 0 10.24 0s10.24 4.588 10.24 10.24 -4.588 10.24 -10.24 10.24m0 -19.661C5.079 0.819 0.819 5.079 0.819 10.24S5.079 19.661 10.24 19.661 19.661 15.401 19.661 10.24 15.401 0.819 10.24 0.819" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    color: customization?.textColor,
                    fontSize: customization?.textSize,
                    fontWeight: customization?.textWeight,
                  }}
                  className="truncate"
                >
                  {customization?.secondText}
                </div>
                <div
                  style={{
                    color: customization?.accentPriceTextColor,
                    fontSize: customization?.priceTextSize,
                    fontWeight: customization?.priceTextWeight,
                  }}
                >
                  ₺{customization?.secondPrice}
                </div>
              </div>
            )}
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '33%',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <div
                  className="relative border m-[5px]"
                  style={{
                    width: 'fit-content',

                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <div
                    className=" "
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: 5,
                    }}
                  >
                    <img
                      className="shrink-0"
                      src={customization?.thirdBoxIcon}
                      alt=""
                      style={{ width: customization?.iconWidth, aspectRatio: 1 }}
                    />
                  </div>
                </div>
              </div>
              <div
                style={{
                  color: customization?.textColor,
                  fontSize: customization?.textSize,
                  fontWeight: customization?.textWeight,
                }}
                className="truncate"
              >
                {customization?.thirdText}
              </div>
              <div
                style={{
                  color: customization?.priceTextColor,
                  fontSize: customization?.priceTextSize,
                  fontWeight: customization?.priceTextWeight,
                }}
              >
                ₺{customization?.thirdPrice}
              </div>
            </div>
          </div>
          <div
            style={{
              marginTop: 10,
            }}
          >
            <div style={{ width: '100%', background: '#D2D5D8', borderRadius: '3px', overflow: 'hidden' }}>
              <div
                style={{
                  width: '95%',
                  height: '5px',
                  background: customization?.barColor,
                  transition: 'width 0.3s ease',
                }}
              ></div>
            </div>
            <div
              style={{
                textAlign: 'right',
                fontSize: '10px',
                fontWeight: '600',
                color: customization?.barColor,
              }}
            >
              95%/100%
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
export default CargoBar_1;
